import React from 'react';
import styled from 'styled-components';
import Paper from 'components/Paper';
import FilterSelection from './components/FilterSelection';
import FilterChip from './components/FilterChip';
import InventoryTable from './components/InventoryTable';
import Tabs from './interfaces/Tabs';
import DownloadCSV from './components/DownloadCSV';
import {InventoryState} from './reducer/InventoryReducer';

const StyledFilterContainer = styled.div`
  display: flex;
  gap: 48px;
  justify-content: space-between;
  margin-bottom: 16px;
`;

interface InventoriesProps {
  selectedTab: Tabs;
  invState: InventoryState;
  isPending: boolean;
  handleFilterChange: (filter: string[], category: string) => void;
  handleClearFilters: () => void;
}

function Inventories({
  selectedTab,
  invState,
  isPending,
  handleFilterChange,
  handleClearFilters,
}: InventoriesProps) {
  return (
    <>
      <FilterChip
        invState={invState}
        handleFilterChange={handleFilterChange}
        selectedTab={selectedTab}
      />
      <Paper>
        <StyledFilterContainer>
          <FilterSelection
            isDisabled={isPending}
            invState={invState}
            selectedTab={selectedTab}
            handleFilterChange={handleFilterChange}
            handleClearFilters={handleClearFilters}
          />
          <DownloadCSV invState={invState} />
        </StyledFilterContainer>

        <InventoryTable invState={invState} />
      </Paper>
    </>
  );
}

export default Inventories;
